import { render, staticRenderFns } from "./Tournament2024.vue?vue&type=template&id=f660c1c4&scoped=true"
import script from "./Tournament2024.vue?vue&type=script&lang=js"
export * from "./Tournament2024.vue?vue&type=script&lang=js"
import style0 from "./Tournament2024.vue?vue&type=style&index=0&id=f660c1c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f660c1c4",
  null
  
)

export default component.exports